const formatNumber = (num, opts = {}) => {
	if(num || num === 0) {
		let options = {
			showDecimals: true,
			decimals: 2,
			...opts
		};

		let [plainNum, decimals] = (typeof num !== 'string' ? num.toFixed(options.decimals) : num).split('.');
		let result = plainNum.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

		if (options.showDecimals) {
			result += ',' + (decimals ? decimals : ('0').repeat(options.decimals));
		}

		return result;
	}
	else { return ''; }
}

export default formatNumber